// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './router/index.js'
// import 'lib-flexible/flexible.js'
import axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import './assets/icon/iconfont.css'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import vPage from 'v-page';
import './assets/share.js'

import Share from 'vue-social-share'
import Viewer from 'v-viewer'
import './assets/viewer.css'
Vue.use(Viewer)
import './assets/phone.js'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)

import gallery from 'img-vuer'
Vue.use(gallery, {
  swipeThreshold: 150 // default 100 ,new in 0.12.0
})

Vue.use(Share)
import 'vue-social-share/dist/client.css';

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)

Vue.use(vPage);
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(VueAwesomeSwiper, /* { default global options } */)


import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video
/* eslint-disable no-new */
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
})
new Vue({
  el: '#app',
  router,
  components: {App},
  render: h => h(App),
  /* 这句非常重要，否则预渲染将不会启动 */
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js